import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema, useTheme } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Organizations Management Services
 * !== 조직 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/orgz`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/orgz`,
    cstm_role_api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/cstm-role/mgmt`,
    nodes: [],
};

export const URLS = {
    ptli0912001q: `${BASE.path}/ptli0912001q`, // Organizations List !==  조직 목록 ==!
};

export const APIS = {
    // Check Organizations List !== 조직 목록 조회 ==!
    getOrgzList: (data: any) => {
        return api.get(`${BASE.api}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Organizations details inquiry !== 조직 상세 정보 조회 ==!
    getOrgzInfo: (cstmOrgzId: any) => {
        return api.get(`${BASE.api}/${cstmOrgzId}`);
    },
    // Sub organization COMBO search on parent detailed organization ID !== 상위상세조직ID에 하위 조직 COMBO 조회 ==!
    getSubOrgzList: (cstmOrgzTpCd: any) => {
        return api.get(`${BASE.api}/sub/${cstmOrgzTpCd}`);
    },
    // Create Organizations !== 조직 생성 ==!
    createOrgz: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update Organizations !==  조직 수정 ==!
    updateOrgz: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    // Delete Organizations !== 조직 삭제 ==!
    deleteOrgz: (cstmOrgzId: any) => {
        return api.delete(`${BASE.api}/${cstmOrgzId}`);
    },
    // Check for duplicate organizations !== 중복된 세관이나 유닛 체크 ==!
    getDuplCheck: (data: any) => {
        return api.get(`${BASE.api}/getDuplCheck`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getSctnList: () => api.get(`${BASE.cstm_role_api}/sctnList`),
};

export const SF_ORGZ_SRCH: TFormSchema = {
    id: "form_orgzSrch",
    schema: {
        cstmSctnCd: { type: "code", label: "L_CSTM_SCTN_CD", required: true, area: "cstmOrgzCd" },
        langCd: { type: "text", label: "L_LANG_CD" },
    },
};

export const SG_SCTN_LIST: TGridSchema = {
    id: "grid_sctnList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_CSTM_SCTN_CD", binding: "cstmSctnCd", width: 150 }] },
        { cells: [{ header: "L_CSTM_SCTN_NM", binding: "cstmSctnNm", width: "*" }] },
        // { cells: [{ header: "L_CSTM_OFCE_CD", binding: "cstmOfceCd", width: 150 }] },
    ],
    body: [
        {
            cells: [{ binding: "cstmSctnCd" }],
        },
        {
            cells: [{ binding: "cstmSctnNm" }],
        },
    ],
};

export const SF_ORGZ_INFO: TFormSchema = {
    id: "form_orgzInfo",
    schema: {
        uprCstmOrgzId: {
            type: "code",
            area: "orgz",
            label: "L_UPR_CSTM_ORGZ_ID",
            popupSize: "md",
            labelSize: 3,
        },
        cstmOrgzCd: {
            type: "code",
            area: "orgzSub",
            label: "L_CSTM_ORGZ_ID",
            popupSize: "md",
            labelSize: 3,
        },
        cstmOrgzTpCd: {
            type: "select",
            label: "L_ORGZ_TP",
            area: "comnCd",
            comnCd: "PTL0021",
            rows: 5,
            labelSize: 3,
        },
        cstmOrgzNm: { type: "text", label: "L_ORGZ_NM", labelSize: 3 },
        newYn: { type: "boolean", label: "L_NEW_YN", labelSize: 3 },
        rootYn: { type: "boolean", label: "L_ROOT_YN", labelSize: 3 },
        cstmOrgzId: { type: "text" },
    },
};
